class MobileMenu {
    // 1. describe and create/initiate our object
    constructor() {
        this.hamburger = document.querySelector('#hamburger');
        this.menuClose = document.querySelector('#menu-close');
        this.mobileMenu = document.querySelector('.header__mobile-menu');
        this.mobileMenuWrapper = document.querySelector('.header__mobile-menu--wrapper');
        this.pageLogo = document.querySelector('.header__logo');
        this.langMenuWrapper = document.querySelector('.header__mobile-menu-lang');
        if (this.hamburger && this.mobileMenu && this.pageLogo && this.langMenuWrapper && this.menuClose && this.mobileMenuWrapper) {
            this.events();
        }
    }

    // 2. events
    events() {
        this.hamburger.addEventListener("click", () => {
            this.handleHamburgerClick();
        });
        this.menuClose.addEventListener("click", () => {
            this.handleMenuCloseClick();
        });
    }

    // 3. methods (function, action...)
    handleHamburgerClick() {
        this.mobileMenu.classList.add('expand');
        this.menuClose.classList.remove('hidden');
        this.mobileMenuWrapper.classList.remove('closed');
        this.hamburger.classList.add('hidden');
        if(this.mobileMenu.classList.contains("expand")) {
            this.pageLogo.classList.add('moved');
            this.langMenuWrapper.classList.add('opened');
        }
    }
    handleMenuCloseClick() {
        this.mobileMenuWrapper.classList.add('closed');
        this.hamburger.classList.remove('hidden');
        this.menuClose.classList.add('hidden');
        this.mobileMenu.classList.remove('expand');
        if(!this.mobileMenu.classList.contains("expand")) {
            this.pageLogo.classList.remove('moved');
            this.langMenuWrapper.classList.remove('opened');
        }
    }
}

export default MobileMenu;
